import { getPath } from '@/router/common'

const baseUrl = {
  title: '上传图片',
  path: 'UploadImg'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'UploadIndex',
    component: () => import(/* webpackChunkName: "UploadIndex" */ '@/views/uploadImg/index.vue'),
    meta: {
      title: '上传图片'
    }
  },
  {
    path: getPath('receipt', baseUrl),
    name: 'receipt',
    component: () => import(/* webpackChunkName: "UploadIndex" */ '@/views/uploadImg/receipt.vue'),
    meta: {
      title: '回单图片'
    }
  },
]
